<template>
  <div class="container">
    <a-card>
      <customize-form-info ref="generalData" :infoData="_generalData" />
    </a-card>
    <a-card title="Business Summary" style="line-height: 24px">
      {{ (this.detail.summaryVO && this.detail.summaryVO.text) || '' }}
    </a-card>
    <a-card title="Contact and General Information">
      <customize-form-info ref="contactData" :infoData="_contactData" />
    </a-card>
    <a-card title="Score Information">
      <div class="scoreBox">
        <div class="leftBox">
          <div>
            <p>
              <span>
                Frisk Score:
                {{
                  this.detail.businessVO && this.detail.businessVO.friskScore
                }}
              </span>
              <span>
                As Of:
                {{
                  this.detail.businessVO &&
                    this.detail.businessVO.friskScoreDate
                }}
              </span>
            </p>
            <p>
              <span>
                Z Score:
                {{ this.detail.businessVO && this.detail.businessVO.zscore }}
              </span>
              <span>
                As Of:
                {{
                  this.detail.businessVO && this.detail.businessVO.zscoreDate
                }}
              </span>
            </p>
          </div>
          <a-table
            :data-source="detail.friskhistoryVOList"
            :columns="friskHistorySchema"
            style="margin-top: 80px"
          ></a-table>
        </div>
        <div class="rightBox">
          <p style="margin-bottom: 20px">Frisk Score</p>
          <score-bar
            :scaleArr="[0, 2.5, 5, 7.5, 10]"
            :score="friskScore"
          ></score-bar>
          <ECharts :options="option"></ECharts>
          <ECharts :options="ZscoreOption"></ECharts>
        </div>
      </div>
    </a-card>
    <a-card title="Annual Financial Statements">
      <div class="annualTitle">
        <span style="font-weight: bold">* Balance sheet</span>
      </div>
      <!--        table-->
      <!--      current asset-->
      <table-view
        style="margin-top:20px;"
        :showPage="false"
        tableCardTitle="Current Assets"
        :columns="_colModel"
        rowKey="id"
        :pagination="false"
        :data="_currentAssetData"
      ></table-view>
      <!--     non current asset-->
      <table-view
        :showPage="false"
        tableCardTitle="Non-Current Assets"
        rowKey="id"
        :pagination="false"
        :columns="_colModel"
        :data="_nonCurrentAsset"
      ></table-view>
      <!--      current liabilities-->
      <table-view
        :showPage="false"
        tableCardTitle="Current Liabilities"
        rowKey="id"
        :pagination="false"
        :columns="_colModel"
        :data="_currentLiabilities"
      ></table-view>
      <!--      Non-Current Liabilities -->
      <table-view
        :showPage="false"
        tableCardTitle="Non-Current Liabilities"
        :pagination="false"
        rowKey="id"
        :columns="_colModel"
        :data="_nonCurrentLiabilities"
      ></table-view>
      <!--      Shareholders' Equity -->
      <table-view
        :showPage="false"
        tableCardTitle="Shareholders' Equity"
        rowKey="id"
        :pagination="false"
        :columns="_colModel"
        :data="_shareHolders"
      ></table-view>
      <!--      Supplemental Information-->
      <table-view
        :showPage="false"
        tableCardTitle="Supplemental Information"
        rowKey="id"
        :columns="_colModel"
        :pagination="false"
        :data="_suppleData"
      ></table-view>
      <!--  Cash Flow Statement  -->
      <div class="annualTitle">
        <span style="font-weight: bold">* Income Statement</span>
      </div>
      <!--    Income Statement  -->
      <table-view
        style="margin-top:20px;"
        :showPage="false"
        tableCardTitle="Revenue"
        :pagination="false"
        rowKey="id"
        :columns="_colModel"
        :data="_revenueData"
      ></table-view>
      <!--      Operating Expense-->
      <table-view
        :showPage="false"
        tableCardTitle="Operating Expense"
        :pagination="false"
        rowKey="id"
        :columns="_colModel"
        :data="_expenseData"
      ></table-view>
      <!--      Non-Operating Expense/Income-->
      <table-view
        :showPage="false"
        tableCardTitle="Non-Operating Expense/Income"
        rowKey="id"
        :pagination="false"
        :columns="_colModel"
        :data="_noeiData"
      ></table-view>
      <!--      Extraordinary Items -->
      <table-view
        rowKey="id"
        :showPage="false"
        tableCardTitle="Extraordinary Items"
        :pagination="false"
        :columns="_colModel"
        :data="_extraordinaryData"
      ></table-view>
      <!--      Supplemental and Per Share Items-->
      <table-view
        :showPage="false"
        tableCardTitle="Supplemental and Per Share Items"
        :pagination="false"
        :columns="_colModel"
        rowKey="id"
        :data="_supplementalData"
      ></table-view>
      <!--  Cash Flow Statement  -->
      <div class="annualTitle">
        <span style="font-weight: bold">* Cash Flow Statement</span>
      </div>
      <!--      Cash Flows from Operating Activity-->
      <table-view
        style="margin-top:20px;"
        rowKey="id"
        :showPage="false"
        tableCardTitle="Cash Flows from Operating Activities"
        :pagination="false"
        :columns="_colModel"
        :data="_operatingData"
      ></table-view>
      <!--    Cash Flows from Financing Activities  -->
      <table-view
        :showPage="false"
        rowKey="id"
        tableCardTitle="Cash Flows from Financing Activities"
        :pagination="false"
        :columns="_colModel"
        :data="_financingData"
      ></table-view>
      <!--     Supplemental Disclosures -->
      <table-view
        :showPage="false"
        tableCardTitle="Supplemental Disclosures"
        rowKey="id"
        :pagination="false"
        :columns="_colModel"
        :data="_disclosuresData"
      ></table-view>
      <!--  Ratios  -->
      <div class="annualTitle">
        <span style="font-weight: bold">* Income Statement</span>
      </div>
      <!--    ratios  -->
      <table-view
        style="margin-top:20px;"
        rowKey="id"
        :pagination="false"
        :showPage="false"
        tableCardTitle="Performance ratios"
        :columns="_colModel"
        :data="_ratiosData"
      ></table-view>
      <!--      Liquidity ratios-->
      <table-view
        :showPage="false"
        tableCardTitle="Liquidity ratios"
        :pagination="false"
        :columns="_colModel"
        rowKey="id"
        :data="_liquidityData"
      ></table-view>
      <!--      Efficiency ratios-->
      <table-view
        :showPage="false"
        tableCardTitle="Efficiency ratios"
        :pagination="false"
        :columns="_colModel"
        rowKey="id"
        :data="_effRatioData"
      ></table-view>
      <!--      Leverage ratios-->
      <table-view
        :showPage="false"
        :pagination="false"
        tableCardTitle="Leverage ratios"
        rowKey="id"
        :columns="_colModel"
        :data="_leverageData"
      ></table-view>
      <!--      long term obligations-->
      <table-view
        :showPage="false"
        tableCardTitle="Long Term Obligations"
        :pagination="false"
        rowKey="id"
        :columns="_colModel"
        :data="_longTermObligationData"
      ></table-view>
      <!--      Capital lease obligations-->
      <table-view
        :showPage="false"
        :pagination="false"
        tableCardTitle="Capital lease obligations"
        :columns="_colModel"
        rowKey="id"
        :data="_leaseObData"
      ></table-view>
      <!--      Operating Lease Obligations-->
      <table-view
        :pagination="false"
        :showPage="false"
        tableCardTitle=" Operating Lease Obligations"
        :columns="_colModel"
        rowKey="id"
        :data="_operatingOblData"
      ></table-view>
      <!--      Rate of Return-->
      <table-view
        :pagination="false"
        :showPage="false"
        tableCardTitle="Rate of Return"
        rowKey="id"
        :columns="_colModel"
        :data="_returnData"
      ></table-view>
    </a-card>
  </div>
</template>

<script>
import { getCrmFinancialReport } from '../../api'
import ScoreBar from '../crm-report/components/score-bar'
import CustomizeFormInfo from '../crm-report/components/CustomizeFormInfo'
import mixins from './mixins'
import { mapGetters } from 'vuex'
import numeral from 'numeral'
import 'echarts'
import ECharts from 'vue-echarts'
// import ECharts from 'echarts'
import { TableView } from 'lxfintech-fe'
export default {
  name: 'crm-financial-report',
  mixins: [mixins],
  components: { ScoreBar, TableView, CustomizeFormInfo, ECharts },
  data() {
    const option = {
      title: {
        text: 'Frisk Score',
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          label: {
            backgroundColor: '#6a7985',
          },
        },
      },
      xAxis: {
        type: 'category',
        data: [],
      },
      yAxis: {
        type: 'value',
      },
      series: [
        {
          name: 'Frist Score',
          data: [],
          type: 'line',
        },
      ],
    }
    const ZscoreOption = {
      title: {
        text: 'Z Score',
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          label: {
            backgroundColor: '#6a7985',
          },
        },
      },
      xAxis: {
        type: 'category',
        data: [],
      },
      yAxis: {
        type: 'value',
      },
      series: [
        {
          name: 'Z Score',
          data: [],
          type: 'line',
        },
      ],
    }
    const formatAmount = num => {
      return numeral(num).format('0,0.00')
    }
    return {
      option,
      ZscoreOption,
      radio: '',
      formatAmount,
      detail: {},
      friskHistorySchema: [
        { dataIndex: 'date', title: 'Date' },
        { dataIndex: 'averageFriskScore', title: 'Frisk Score History' },
        { dataIndex: 'zscore', title: 'Z Score History' },
      ],
      // table
      // current assets
      colYears: [], // column 纵向
      currentAssetData: [],

      currentAssetKeys: [
        'cashandShortTermInvestments',
        'accountsReceivable',
        'notesReceivableShortTerm',
        'otherReceivables',
        'inventory',
        'prepaidExpenses',
        'otherCurrentAssetsTotal',
        'totalCurrentAssets',
      ],
      nonCurrentAssetKeys: [
        'propertyPlantEquipment',
        'goodwillNet',
        'intangiblesNet',
        'longTermInvestments',
        'noteReceivableLongTerm',
        'otherAssetsTotal',
        'otherLongTermAssetsTotal',
        'totalAssets',
      ],
      currentLiabilityKeys: [
        'accountsPayable',
        'accruedExpenses',
        'notesPayableShortTermDebt',
        'currentPortLtDebtCapitalLeases',
        'otherCurrentLiabilitiesTotal',
        'totalCurrentLiabilities',
      ],
      nonCurrentLiabilities: [
        'totalLongTermDebt',
        'capitalLeaseObligations',
        'deferredIncomeTax',
        'cminorityInterest',
        'otherLiabilitiesTotal',
        'totalLiabilities',
      ],
      shareHolderKeys: [
        'commonStock',
        'additionalPaidInCapital',
        'retainedEarnings',
        'treasuryStockCommon',
        'otherEquityTotal',
        'totalEquity',
        'totalLiabilitiesShareholdersEquity',
      ],
      suppleKeys: ['totalCommonSharesOutstanding'],
      // income keys
      revenueKeys: ['revenue', 'totalSales'],
      expenseKeys: [
        'costOfGoods',
        'sga',
        'depreciationAmortization',
        'otherOperatingExpensesTotal',
        'totalOperatingExpense',
        'unusualIncomeExpense',
        'operatingIncome',
      ],
      noeiKeys: [
        'interestExpenseNetNonOperating',
        'interestInvestmentIncomeNonOperating',
        'otherNet',
        'incomeBeforeTax',
        'incomeTaxTotal',
        'incomeAfterTax',
        'iminorityInterest',
      ],
      extraordinaryKeys: ['totalExtraordinaryItems', 'netIncome'],
      spmentKeys: [
        'basicPrimaryEpsInclExtraItems',
        'dilutedEpsInclExtraItems',
        'interestExpenseSupplemental',
        'interestCapitalizedSupplemental',
        'depreciationAmortizationSupplemental',
      ],
      // cash flow
      operatingKeys: [
        'cnetIncome',
        'depreciationDepletion',
        'nonCashItems',
        'changesInWorkingCapital',
        'netCashOperating',
        'capitalExpenditures',
        'otherInvestingCashFlowItemsTotal',
        'totalCashFromInvestingActivities',
      ],
      financingKeys: [
        'financingCashFlowItems',
        'totalCashDividendsPaid',
        'issuanceRetirementOfStockNet',
        'issuanceRetirementOfDebtNet',
        'totalCashFromFinancingActivities',
        'foreignExchangeEffects',
        'netChangeInCash',
        'netCashBeginningBalance',
        'netCashEndingBalance',
      ],
      disclosureKeys: ['cashInterestPaid', 'cashTaxesPaid'],
      // performance
      rationKeys: [
        'grossMargin',
        'sgaOfSales',
        'operatingMarginOfSales',
        'ebitdaMarginOfSales',
        'pretaxIncomeOfSales',
        'netProfitMarginOfSales',
        'incomeTaxOfPretaxIncome',
        'depreciationOfCapEx',
        'depreciationOfPpe',
        'capitalExpenseOfPpe',
        'capExOfWorkingCap',
        'timesInterestEarned',
        'freeCashFlow',
      ],
      liquidityKeys: [
        'currentAssetsOfDebt',
        'workingCapital',
        'workingCapitalOfSales',
        'cashOfDebt',
        'cashRatio',
        'quickAssets',
        'quickAssetsOfDebt',
        'quickRatio',
        'currentRatio',
      ],
      effRatioKeys: [
        'arOfSales',
        'arTurnover',
        'daysSalesOutstanding',
        'inventoryFinanced',
        'inventoryTurnover',
        'daysSalesInventory',
        'inventoryWorkingCapital',
        'apTurnover',
      ],
      leverageKeys: [
        'debtAssetsRatio',
        'debtEquityRatio',
        'debtTangibleNetWorthRatio',
        'liabilitiesEquityRatio',
        'liabilitiesNetWorthRatio',
        'netTangibleAssets',
        'shortTermDebt',
        'shortTermDebtOfDebt',
        'shortTermDebtOfWorkingCapital',
        'tangibleNetWorth',
        'tierOneCapitalPercent',
        'totalCapitalPercent',
        'totalDebt',
      ],
      obligationKeys: [
        'longTermDebt1',
        'longTermDebt2',
        'longTermDebt3',
        'longTermDebt4',
        'longTermDebt5',
        'longTermDebtRemaining',
        'totalLongTermDebtSupp',
      ],
      leaseObjKeys: [
        'capitalLeases1',
        'capitalLeases2',
        'capitalLeases3',
        'capitalLeases4',
        'capitalLeases5',
        'longTermDebtRemaining',
        'totalCapitalLeases',
      ],
      operaingOblKeys: [
        'operatingLeases1',
        'operatingLeases2',
        'operatingLeases3',
        'operatingLeases4',
        'operatingLeases5',
        'operatingLeasesRemaining',
        'totalOperatingLeases',
        'cumulativeObligations3',
      ],
      returnKeys: [
        'returnOnEquity',
        // 'returnOnTangibleNetworth',
        'returnOnNetAssets',
        'returnOnTangibleNetworth',
        // 'ttmDividends',
        'returnOnAssets',
      ],
    }
  },
  computed: {
    ...mapGetters('app', ['bureauReportBasicInfo']),
    friskScore() {
      return this.detail.businessVO && Number(this.detail.businessVO.friskScore)
    },
    _generalData() {
      // 只需要显示以下字段
      const _keys = [
        'name',
        'businessId',
        'tickerSymbol',
        'latestStatementDate',
      ]
      return this.handleCommon(_keys, this.detail.businessVO)
    },
    _contactData() {
      // 只需要显示以下字段
      const _keys = [
        'phoneNumber',
        'webSite',
        'marketCap',
        'employees',
        'emailAddress',
        'employeesAsOfDate',
        'federalTaxId',
        'cikNumber',
        'tickerSymbol',
        'stockExchange',
      ]
      return this.handleCommon(_keys, this.detail.businessVO)
    },
    // table
    // current assets
    _colModel() {
      const _res = [{ title: '', dataIndex: '__name' }]
      this.colYears.forEach(item => {
        _res.push({
          title: `${item}`,
          dataIndex: `annual${item}`,
        })
      })
      return _res
    },
    _currentAssetData() {
      // 根据需要的key摘取数据
      return this.handleCommonTable('balanceVO', this.currentAssetKeys)
    },
    _nonCurrentAsset() {
      return this.handleCommonTable('balanceVO', this.nonCurrentAssetKeys)
    },
    _currentLiabilities() {
      return this.handleCommonTable('balanceVO', this.currentLiabilityKeys)
    },
    _nonCurrentLiabilities() {
      return this.handleCommonTable('balanceVO', this.nonCurrentLiabilities)
    },
    _shareHolders() {
      return this.handleCommonTable('balanceVO', this.shareHolderKeys)
    },
    _suppleData() {
      return this.handleCommonTable('balanceVO', this.suppleKeys)
    },
    _revenueData() {
      return this.handleCommonTable('incomeVO', this.revenueKeys)
    },
    _expenseData() {
      return this.handleCommonTable('incomeVO', this.expenseKeys)
    },
    _noeiData() {
      return this.handleCommonTable('incomeVO', this.noeiKeys)
    },
    _extraordinaryData() {
      return this.handleCommonTable('incomeVO', this.extraordinaryKeys)
    },
    _supplementalData() {
      return this.handleCommonTable('incomeVO', this.spmentKeys)
    },
    _operatingData() {
      return this.handleCommonTable('cashflowVO', this.operatingKeys)
    },
    _financingData() {
      return this.handleCommonTable('cashflowVO', this.financingKeys)
    },
    _disclosuresData() {
      return this.handleCommonTable('cashflowVO', this.disclosureKeys)
    },
    _ratiosData() {
      return this.handleCommonTable('performanceVO', this.rationKeys)
    },
    _liquidityData() {
      return this.handleCommonTable('liquidityVO', this.liquidityKeys)
    },
    _effRatioData() {
      return this.handleCommonTable('efficiencyVO', this.effRatioKeys)
    },
    _leverageData() {
      return this.handleCommonTable('leverageVO', this.leverageKeys)
    },
    _longTermObligationData() {
      return this.handleCommonTable('obligationsVO', this.obligationKeys)
    },
    _leaseObData() {
      return this.handleCommonTable('obligationsVO', this.leaseObjKeys)
    },
    _operatingOblData() {
      return this.handleCommonTable('obligationsVO', this.operaingOblKeys)
    },
    _returnData() {
      return this.handleCommonTable('returnVO', this.returnKeys)
    },
  },
  mounted() {
    this._getCrmDetailDetail()
  },
  methods: {
    // 接口数据
    async _getCrmDetailDetail() {
      try {
        const { id } = this.bureauReportBasicInfo
        const { data } = await getCrmFinancialReport(id)
        this.detail = data
        // statements table column
        if (this.detail) {
          this.detail.statementsVOList &&
            this.detail.statementsVOList.map(item => {
              if (item.baseVO.statementQuarter === '0') {
                this.colYears = this.detail.statementsVOList.map(
                  item =>
                    item.baseVO.statementYear +
                    ` (` +
                    item.baseVO.currencyCode +
                    `)`,
                )
              } else {
                this.colYears = this.detail.statementsVOList.map(
                  item =>
                    item.baseVO.statementYear +
                    ` Q` +
                    item.baseVO.statementQuarter +
                    ` (` +
                    item.baseVO.currencyCode +
                    `)`,
                )
              }
            })
        }
        // Z-score
        const ZxData =
          this.detail.zscoreHistoryVOList &&
          this.detail.zscoreHistoryVOList.map(item => item.date)
        const ZyData =
          this.detail.zscoreHistoryVOList &&
          this.detail.zscoreHistoryVOList.map(item => item.zscore)
        this.ZscoreOption = {
          ...this.ZscoreOption,
          xAxis: {
            ...this.ZscoreOption.xAxis,
            data: ZxData,
          },
          series: [
            {
              type: 'line',
              data: ZyData,
            },
          ],
        }
        // frisk echart options
        const xData =
          this.detail.friskhistoryVOList &&
          this.detail.friskhistoryVOList.map(item => item.date)
        const yData =
          this.detail.friskhistoryVOList &&
          this.detail.friskhistoryVOList.map(item => item.averageFriskScore)
        this.option = {
          ...this.option,
          xAxis: {
            ...this.option.xAxis,
            data: xData,
          },
          series: [
            {
              type: 'line',
              data: yData,
            },
          ],
        }
      } catch (err) {
        console.error(err)
      }
    },
    // 把公共逻辑抽出来
    handleCommon(neededKeys, sourceDataObj = {}) {
      const _res = {}
      const _detailKeys = Object.keys(sourceDataObj) || []
      _detailKeys.forEach(key => {
        if (Object.prototype.hasOwnProperty.call(sourceDataObj, `${key}Str`)) {
          delete sourceDataObj[key]
        }
      })
      // 处理多余字段
      for (const key of neededKeys) {
        if (_detailKeys.indexOf(key) !== -1) {
          _res[key] = sourceDataObj[key]
        }
      }
      return this.handleInfoData(_res)
    },
    handleInfoData(apiData) {
      if (apiData) {
        return Object.keys(apiData).map(key => ({
          key: mixins.methods.transKeyToLabel(key),
          value: apiData[key],
        }))
      }
      return []
    },
    transTbData(sourceData) {
      const _arr = []
      if (!sourceData.length) {
        return []
      } else {
        const len = Object.keys(sourceData[0].data)?.length
        for (let i = 0; i < len; i++) {
          const _obj = {}
          for (let j = 0; j < sourceData.length; j++) {
            const key = Object.keys(sourceData[j].data)[i]
            ;(_obj['__name'] = mixins.methods.transKeyToLabel(key)),
              (_obj[`annual${sourceData[j].year}`] =
                typeof Number(sourceData[j].data[key]) === 'number'
                  ? this.formatAmount(sourceData[j].data[key])
                  : sourceData[j].data[key])
          }
          _arr.push(_obj)
        }
      }
      return _arr
    },
    handleCommonTable(taleName, showKeys) {
      const _res = []
      if (
        this.detail &&
        this.detail.statementsVOList &&
        this.detail.statementsVOList.length
      ) {
        this.detail.statementsVOList.forEach(item => {
          const _obj = {}
          Object.keys(item[taleName]).forEach(key => {
            if (showKeys.indexOf(key) !== -1) {
              _obj[key] = item[taleName][key]
            }
          })
          _res.push(_obj)
        })
      }
      for (let i = this.colYears.length - 1; i >= 0; i--) {
        if (_res.length) {
          _res[i]['year'] = this.colYears[i]
        }
      }
      // 处理成需要的数据结构
      for (let i = 0; i < _res.length; i++) {
        _res[i]['data'] = {}
        for (const _key of showKeys) {
          _res[i]['data'][_key] = _res[i][_key]
          delete _res[i][_key]
        }
      }
      return this.transTbData(_res)
    },
  },
}
</script>

<style scoped lang="less">
.leftBox {
  width: 50%;
  box-sizing: border-box;
  padding-right: 20px;
  padding-top: 20px;
  & > div {
    & > p {
      display: flex;
      margin-bottom: 10px;
      justify-content: space-between;
    }
  }
}
.rightBox {
  box-sizing: border-box;
  width: 60%;
  height: 100%;
}
.ECharts {
  display: inline-block;
  width: 33%;
}
.annualTitle {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/deep/ .table-header {
  th {
    background-color: #f5f5fa;
    height: 56px;
    font-size: 14px;
    color: #000;
    line-height: 20px;
  }
}
.scoreBox {
  width: 100%;
  height: 100%;
  font-size: 14px;
  display: flex;
}
.card {
  width: 100%;
  margin-bottom: 24px;
}
</style>
